// extracted by mini-css-extract-plugin
module.exports = {"root":"menu-languages_root__1dTPK","item":"menu-languages_item__7Sr8b"};